import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Button, Glyphicon, OverlayTrigger, Tooltip } from "react-bootstrap";

class Delete extends Component {
  render() {
    const tooltip = <Tooltip id="delete-button-tooltip">Delete</Tooltip>;

    return (
      <OverlayTrigger placement="top" overlay={tooltip}>
        <Button bsStyle="danger" {...this.props}>
          <Glyphicon glyph="trash" />
        </Button>
      </OverlayTrigger>
    );
  }
}

export default inject("stores")(observer(Delete));



// WEBPACK FOOTER //
// ./src/Core/Components/Buttons/Delete.js